import axios from "axios";
export const http_admin = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiIwMUhNNUtON05ZM1JSWDVDRDI1Ujc5NkFZVCIsImVtYWlsIjoiYWRtaW4iLCJuYW1lIjoiQWRtaW5pc3RyYXRvciIsInJvbGUiOiJhZG1pbiIsImV4cCI6MTcxNDU4NDYyNiwiaWF0IjoxNzEzOTc5ODI2fQ.2yQKgid-zPvtrvquDD2P-7wO2yR5DD8Tbdi-i8kxYdc`,
  },
  withCredentials: false,
});
